import type { BranchQueryArgs } from 'app/branches/types';
import { mutateAdmin, queryAdmin } from '../graphql-client.js';
import type { RestoreSchemaRequest, RestoreSchemaResponse } from './actions.js';
import type { GetSchemaVersionRequest, GetSchemaVersionResponse } from './slices/get-schema-version.js';
import type { SchemaHistoryRequest } from './slices/get-schema-version-list.js';

export const GET_SCHEMA_VERSION = /* GraphQL */ `
  query ($version: Int!) {
    getSchemaVersion(version: $version) {
      schema
      status
    }
  }
`;

export async function getSchemaVersion(variables: GetSchemaVersionRequest): Promise<GetSchemaVersionResponse> {
  const res = await queryAdmin(GET_SCHEMA_VERSION)(variables);
  return res.getSchemaVersion;
}

export const GET_SCHEMA_VERSION_LIST = /* GraphQL */ `
  query ($from: Int, $size: Int) {
    versionList: getSchemaVersionList(from: $from, size: $size) {
      total
      items {
        version
        schemaVersion
        updated
        shapeCount
        mutationCount
        queryCount
        updatedBy {
          id
          fullName
          avatarPath
        }
      }
    }
  }
`;

export async function getSchemaVersionList(variables: SchemaHistoryRequest) {
  return queryAdmin<SchemaHistoryRequest>(GET_SCHEMA_VERSION_LIST)(variables);
}

export const RESTORE_SCHEMA_VERSION_MUTATION = /* GraphQL */ `
mutation ($version: Int!) {
  restoreSchemaVersion(version: $version) {
    version
  }
}
`;

export async function restoreSchemaVersion(variables: RestoreSchemaRequest): Promise<RestoreSchemaResponse> {
  const res = await mutateAdmin(RESTORE_SCHEMA_VERSION_MUTATION)(variables);
  return res.restoreSchemaVersion;
}

export type ClearCacheVariables = {
  input: BranchQueryArgs & {
    serviceId?: string | undefined;
    tags?: string[] | undefined;
  };
};

export type ClearCacheData = {
  clearCache: {
    total: number;
  };
};

export const CLEAR_CACHE_MUTATION = /* GraphQL */ `
mutation ($input: ClearCacheInput!) {
  clearCache(input: $input) {
    total
  }
}
`;

export async function clearCache(variables: ClearCacheVariables): Promise<ClearCacheData> {
  return mutateAdmin<ClearCacheData>(CLEAR_CACHE_MUTATION)(variables);
}
